<template>
  <div class="navbar">
    <b-container>
      <b-navbar variant="light" fixed="top">
        <b-navbar-brand>ADMIN MODE</b-navbar-brand>

        <b-navbar-nav class="ml-auto">
          <b-dropdown text="Upload" right>
            <b-dropdown-item v-b-modal="'modal-upload'" @click="changeUploadOption('toWebtoon')">Comic</b-dropdown-item>
            <b-dropdown-item v-b-modal="'modal-upload'" @click="changeUploadOption('toGallery')">Gallery</b-dropdown-item>
          </b-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="mx-1">
          <b-dropdown text="Manage" class="ml-2" right>
            <b-dropdown-item href="#/managecomic">Comic</b-dropdown-item>
            <b-dropdown-item href="#/managegallery">Gallery</b-dropdown-item>
            <b-dropdown-item href="#/managebanners">Banners</b-dropdown-item>
          </b-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="mx-1">
          <b-button class="ml-2" v-b-modal="'modal-mail'" right>
            Mail subscribers
          </b-button>
        </b-navbar-nav>

        <b-navbar-nav class="mx-1">
          <b-button class="mx-1" @click="signOut" right>
            Sign Out
          </b-button>
        </b-navbar-nav>        
      </b-navbar>

      
      <UploadView v-bind:uploadOptionProp="uploadOption"></UploadView>
      <MailWidget></MailWidget>
      
    </b-container>
  </div>
  
</template>

<script>
import UploadView from '@/components/UploadView'
import MailWidget from '@/components/MailWidget'
import {auth} from '@/firebase/init'
export default {
  components: {
    UploadView,
    MailWidget
  },
  data() {
    return {
      uploadOption: null
    }
  },
  methods: {
    changeUploadOption(option) {
      if (option === 'toWebtoon' || option === 'toGallery') {
        this.uploadOption = option;
        // console.log(this.uploadOption);
      }
    },
    signOut() {
      auth.signOut()
        .then(() =>{
          this.$router.push('/'); // replace '' with url path for admin mode
          console.log("sign out success");
          // window.location.assign("http://localhost:8080/");
          window.location.assign(window.location.origin);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>

<style scoped>
  .navbar {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    padding-right: 4em;
    padding-left: 4em;
    margin-bottom: 4em;
  }
</style>